<template>
  <AuthContainer>
    <template #form>
      <NcpPasswordReset/>
    </template>
  </AuthContainer>
</template>
<script>

import {
  AuthContainer,
  NcpPasswordReset
} from '../components';
import AnonymousPage from '@pages/AnonymousPage.js';

export default {
  name: 'ncp-password-reset-page',
  components: {
    NcpPasswordReset,
    AuthContainer,
  },
  extends: AnonymousPage,
  props: {
    title: {
      type: String,
      required: false,
      default: function () {
        return this.$t('reset.password');
      }
    }
  },
  methods: {
    getTitle() {
      return `${ this.title } | ${ this.publication.title }`;
    },
    getRedirectLocation() {
      return '/';
    }
  }
};

</script>
